import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=a9e9bcf6&scoped=true"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=a9e9bcf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e9bcf6",
  null
  
)

export default component.exports